import {waitingDialog} from "../../library/waiting-dialog";
import {blockedAllCookies, getCookie} from "../../library/cookies";

$(document).ready(function () {
    let addToCartComponent = $('.add-to-cart-component'),
        priceBoxHeight = addToCartComponent.height(),
        initialPosition = 0;
    
    function scroll() {
        if (addToCartComponent.height()) {
            let currentBottomPosition = $(window).height() + $(window).scrollTop();
            let origOffsetY = isMobileDevice() ? 1 : addToCartComponent.offset().top + priceBoxHeight;
            if (isMobileDevice() && addToCartComponent.hasClass('fixable-add-to-cart')) {
                if (currentBottomPosition >= origOffsetY && initialPosition === 0) {
                    /*addToCartComponent.addClass('fixed-add-to-cart-component');*/
                    initialPosition = origOffsetY;
                } else if (currentBottomPosition < initialPosition || currentBottomPosition === $(window).height()) {
                    /*addToCartComponent.removeClass('fixed-add-to-cart-component');*/
                    initialPosition = 0;
                }
            }
        }
    }
    document.onscroll = scroll;

    $(document).on("click", ".qty-btn-remove", function () {
        let btn = $(this);
        let input = btn.siblings('.qty-display');
        let quantity = parseInt(input.val()) - 1;
        validateQuantityInput(input, quantity);
    });
    $(document).on("click", ".qty-btn-add", function () {
        let btn = $(this);
        let input = btn.siblings('.qty-display');
        let quantity = parseInt(input.val()) + 1;
        validateQuantityInput(input, quantity);
    });

    $(document).on("keydown", ".qty-display", function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });

    $(document).on("keyup", ".qty-display", function (e) {
        if ($(this).val().length) {
            let quantity = parseInt($(this).val());
            validateQuantityInput($(this), quantity);
        }
    });
});

function validateQuantityInput(input, quantity) {
    quantity = +quantity || 1; //make sure it's a number
    quantity = Math.max(quantity, 1);

    let btnRemove = input.siblings('.qty-btn-remove');
    if (quantity === 1) {
        btnRemove.attr('disabled', true);
    } else {
        btnRemove.attr('disabled', false);
    }

    input.val(quantity).trigger('change');
}

let addToCart;
export function addToCartAjax(data, success, error) {
    if (typeof addToCart == 'object') {
        addToCart.abort();
    }
    if (getCookie('_tv_cookie_choice') === "") {
        blockedAllCookies();
        return;
    }
    waitingDialog.show();
    addToCart = $.ajax({
        type: 'POST',
        url: '/ajax/shopping/add-to-cart',
        data: data,
        success: function (data) {
            waitingDialog.hide();
            if (data.done) {
                typeof success === 'function' && success(data);
            } else {
                typeof error === 'function' && error(data);
            }
        },
        error: function (data) {
            waitingDialog.hide();
            typeof error === 'function' && error(data);
        }
    });
}

let addToCartMultiple;
export function addToCartMultipleAjax(data, success, error) {
    if (typeof addToCart == 'object') {
        addToCartMultiple.abort();
    }
    if (getCookie('_tv_cookie_choice') === "") {
        blockedAllCookies();
        return;
    }
    waitingDialog.show();
    addToCartMultiple = $.ajax({
        type: 'POST',
        url: '/ajax/shopping/add-to-cart-multiple',
        data: data,
        success: function (data) {
            waitingDialog.hide();
            if (data.done) {
                typeof success === 'function' && success(data);
            } else {
                typeof error === 'function' && error(data);
            }
        },
        error: function (data) {
            waitingDialog.hide();
            typeof error === 'function' && error(data);
        }
    });
}

function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}